import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../../services/api";

import "../../css/login.css";
import unlock from '../../../../media/eye1.png';
import lock from '../../../../media/eye2.png';
import { toast } from "react-toastify";

const ResetPassword = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const [errors, setErrors] = useState({});
  const [info, setInfo] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const getError = (field) => {
      if (!errors[field]) return null;

      return Array.isArray(errors[field])
        ? errors[field][0]
        : errors[field];
    };

  

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrors({});
    setInfo("");

   

    try {
      const res = await api.resetPassword({
        uid,
        token,
        password,
        confirmPassword: confirm,
      });

      if (res.success) {
        setInfo("Password aggiornata con successo");

        setTimeout(() => navigate("/login"), 1000);
      }
    } catch (err) {
    
      if (err.response?.data) {
        setErrors(err.response.data);
      } else {
        toast.error("Errore durante l'aggiornamento");
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-flex-wrapper">
      <h1 className="login-title">Reset Password</h1>

      <div className="login-form-box">

        <form onSubmit={handleSubmit}>

          <div className="form-group">
            <label>Nuova password:</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                
                className="password-input"
              />

              <button
                type="button"
                onClick={() => setShowPassword(prev => !prev)}
                className="toggle-password-btn"
              >
                <img
                  src={showPassword ? lock : unlock}
                  alt="toggle password"
                  className="eye-icon"
                />
              </button>
            </div>
            {getError("password") && (<span className="error">{getError("password")}</span>)}
          </div>

          <div className="form-group">
            <label>Conferma password:</label>
            <div className="password-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                
                className="password-input"
              />

              <button
                type="button"
                onClick={() => setShowConfirmPassword(prev => !prev)}
                className="toggle-password-btn"
              >
                <img
                  src={showConfirmPassword ? lock : unlock}
                  alt="toggle confirm password"
                  className="eye-icon"
                />
              </button>
            </div>
            {getError("confirmPassword") && (<span className="error">{getError("confirmPassword")}</span>)}
          </div>

          {getError("detail") && (
              <p className="error">{getError("detail")}</p>
            )}

            {getError("non_field_errors") && (
              <p className="error">{getError("non_field_errors")}</p>
            )}
          {info && <p style={{ color: "green" }}>{info}</p>}

          <button type="submit" className="btn-login">
            Aggiorna password
          </button>

        </form>

      </div>
      </div>
    </div>
  );
};

export default ResetPassword;